// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Bar } from 'react-chartjs-2';
import _ from 'lodash';
import { format, compareAsc } from 'date-fns';
// local
import t from 'app/lib/i18n';
// views
import EmptyList from 'app/ui/commons/emptyList/EmptyList';

const DATE_FORMAT = 'DD/MM/YYYY';

class ReportPrescription extends Component {
    renderEmpty = () => <EmptyList emptyMessage="Não foram encontradas informações para o filtro configurado." />;
    
    renderGrafic(flows) {
        console.log('flows', flows);
        let labels = [];
        const pFlowDatas = {};
        const pPrescDatas = {};

        const options = {
            scales: {
                yAxes: [
                    {
                        ticks: {
                            mode: 'index',
                            beginAtZero: true,
                            steps: 1,
                            max: 15,
                        },
                    },
                ],
            },
        };

        for (let x in flows) {
            const flow = flows[x];
            const sDate = format(new Date(flow.date), DATE_FORMAT);
            labels.push(flow.date);
            pFlowDatas[sDate] = flow.avg;
            pPrescDatas[sDate] = flow.prescription;
        }

        labels = labels.sort((a, b) => {
            return compareAsc(a, b);
        });

        let repeatFlow = 0;
        let repeatPresc = 0;
        const flowDatas = [];
        const prescDatas = [];

        for (let y in labels) {
            const label = format(labels[y], DATE_FORMAT);
            if (label in pPrescDatas) {
                repeatPresc = pPrescDatas[label];
            }
            if (label in pFlowDatas) {
                repeatFlow = pFlowDatas[label];
            }
            prescDatas.push(repeatPresc);
            flowDatas.push(repeatFlow);
            labels[y] = label;
        }

        const index = labels.map((label, i) => {
            if (labels.indexOf(label) !== i) return i;
            return false;
        });
        for (let i of index) {
            
            if (i) {
                labels.splice(i, 1);
                flowDatas.splice(i, 1);
                prescDatas.splice(i, 1);
            }
        };

        const dataSet = {
            labels,
            datasets: [
                {
                    label: 'Prescrição',
                    data: prescDatas,
                    fill: false,
                    backgroundColor: '#3C9A50',
                    borderColor: '#3C9A50',
                    borderCapStyle: 'butt',
                },
                {
                    label: 'Fluxo Médio',
                    data: flowDatas,
                    fill: false,
                    backgroundColor: '#747474',
                    borderColor: '#747474',
                    borderCapStyle: 'butt',
                },
            ],
        };

        return <Bar data={dataSet} width={900} height={290} options={options} />;
    }

    renderReport(data) {
        const { dateFrom, dateTo, patient, flows } = data;
        const strPhone = [patient.phone1, patient.phone2, patient.phone3].filter(p => p).join(' / ');
        return (
            <React.Fragment>
                <div className="report">
                    <div className="date">
                        <span className="bold">Período:</span> {dateFrom} à {dateTo}
                    </div>
                    <div className="header">
                        <div className="title">
                            SALVUS ATAS | Relatório de prescrição e fluxo de O<sub>2</sub>
                        </div>
                        <div className="content">
                            <div>
                                Paciente: <span className="bold wrap">{patient.name}</span>
                            </div>
                            <div>
                                Fornecedor: <span className="bold wrap">{patient.supplier.name}</span>
                            </div>
                            <div>
                                Telefone: <span className="bold">{strPhone}</span>
                            </div>
                            <div>
                                Atendimento: <span className="bold">{patient.serviceNumber}</span>
                            </div>
                            <div>
                                Pescrição: <span className="bold">{patient.prescription}L/min</span>
                            </div>
                            <div>
                                CPF: <span className="bold">{patient.cpf}</span>
                            </div>
                            <div>
                                Tipo: <span className="bold">{t(`patient_period_type_${patient.periodType}`)}</span>
                            </div>
                            <div>
                                Plano de Saúde: <span className="bold wrap">{patient.healthInsurence}</span>
                            </div>
                            {patient.rg && (
                                <div>
                                    RG: <span className="bold">{patient.rg}</span>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="body">
                        { this.renderGrafic(flows) }
                    </div>
                </div>
            </React.Fragment>
        );
    }

    render() {
        const { data } = this.props;
        return _.isEmpty(data.flows) ? this.renderEmpty() : this.renderReport(data);
    }
}

ReportPrescription.propTypes = {
    data: PropTypes.object,
};

export default ReportPrescription;
